import { render, staticRenderFns } from "./ReservationTable.vue?vue&type=template&id=39e2ed65&scoped=true&lang=pug"
import script from "./ReservationTable.vue?vue&type=script&lang=ts"
export * from "./ReservationTable.vue?vue&type=script&lang=ts"
import style0 from "./ReservationTable.vue?vue&type=style&index=0&id=39e2ed65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2ed65",
  null
  
)

export default component.exports